import { render, staticRenderFns } from "./AddLayerPanel.vue?vue&type=template&id=38a45762&scoped=true"
import script from "./AddLayerPanel.vue?vue&type=script&lang=ts"
export * from "./AddLayerPanel.vue?vue&type=script&lang=ts"
import style0 from "./AddLayerPanel.vue?vue&type=style&index=0&id=38a45762&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a45762",
  null
  
)

export default component.exports